export const createBoardViewKey = ['createBoardView'];
export const updateBoardViewKey = ['updateBoardView'];
export const duplicateBoardViewKey = ['duplicateBoardView'];
export const reorderBoardViewKey = ['reorderBoardView'];
export const getBoardViewsKey = (boardId: string) => [
  'getBoardViewsKey',
  boardId,
];
